// Sidebar container styles
export const sidebarStyles = {
  w: "64",
  bg: "white",
  _dark: { bg: "gray.800", borderColor: "gray.700" },
  borderRight: "1px",
  borderColor: "gray.200",
  h: "100vh",
  pos: "fixed" as const,
  left: 0,
  top: 0,
  zIndex: 10,
  transition: "width 0.3s ease-in-out",
  overflow: "hidden",
};

// Collapsed sidebar styles
export const collapsedSidebarStyles = {
  ...sidebarStyles,
  w: "16",
  overflow: "hidden",
};

// Base navigation button styles
export const navButtonStyles = {
  variant: "ghost" as const,
  justifyContent: "flex-start" as const,
  px: 4,
  py: 2,
  h: "auto",
  fontWeight: "normal",
  w: "full",
  overflow: "hidden",
};

// Collapsed navigation button styles
export const collapsedNavButtonStyles = {
  variant: "ghost" as const,
  justifyContent: "center" as const,
  px: 2,
  py: 2,
  h: "auto",
  fontWeight: "normal",
  w: "full",
  minW: "auto",
  overflow: "hidden",
};

// Active navigation button styles
export const activeNavButtonStyles = {
  ...navButtonStyles,
  bg: "brand.50",
  color: "brand.700",
  _hover: { bg: "brand.100" },
  _dark: { bg: "brand.800", color: "brand.200" },
};

// Inactive navigation button styles
export const inactiveNavButtonStyles = {
  ...navButtonStyles,
  _hover: { bg: "gray.100", _dark: { bg: "gray.700" } },
};

// Section header styles
export const sectionHeaderStyles = {
  fontSize: "xs",
  fontWeight: "semibold",
  color: "gray.500",
  _dark: { color: "gray.400" },
  my: 2,
  px: 4,
  textTransform: "uppercase" as const,
  letterSpacing: "wider",
};

// Logout button styles
export const logoutButtonStyles = {
  ...navButtonStyles,
  color: "error.solid",
  _hover: { 
    bg: "error.subtle", 
    color: "error.dark",
    _dark: { bg: "error.muted", color: "error.light" } 
  },
  _active: { 
    bg: "error.muted", 
    _dark: { bg: "error.subtle" } 
  },
};

// Toggle button styles
export const toggleButtonStyles = {
  variant: "ghost" as const,
  size: "sm" as const,
  w: "full",
  justifyContent: "center" as const,
  p: 2,
  _hover: { bg: "gray.100", _dark: { bg: "gray.700" } },
}; 